import { DB_PROVIDERS } from "../source/database-reader/configs/db-providers";

export const getDatabaseType = (adapter?: string) => {
    if (typeof adapter !== "string") return null;

    const adapterClear = adapter.replace("Reader", "").replace("Writer", "");
    switch (adapterClear) {
        case "SnowflakeIL":
            return DB_PROVIDERS.SNOWFLAKE.id;
        case "OracleIL":
        case "OutputOracleDatabase":
        case "Oracle":
            return DB_PROVIDERS.ORACLE.id;
        case "AzurePostgreSql":
        case "CloudSqlPostgres":
        case "CloudSqlPostgreSql":
        case "OutputPostgresDatabase":
        case "PostgreSQLDB":
        case "PostgreSQL":
        case "CrunchyDataIL":
        case "NeonIL":
        case "CrunchyData":
        case "Neon":
        case "PostgreSQLIL":
        case "PostgreSQL":
        case "CrunchyDataIL":
        case "NeonIL":
        case "CrunchyData":
        case "Neon":
        case "Lakebase":
            return DB_PROVIDERS.POSTGRES.id;
        case "CloudSqlMySQL":
        case "CloudSqlMySql":
        case "OutputMySQLDatabase":
        case "MySQLDB":
        case "Mysql":
        case "MySQLIL":
        case "Mysql":
            return DB_PROVIDERS.MYSQL.id;
        case "CloudSqlSQLServer":
        case "OutputSQLServerDatabase":
        case "OutputAzureSQLServerDatabase":
        case "MSSQLDB":
        case "MSSql":
        case "MSSQLIL":
        case "MSSql":
            return DB_PROVIDERS.SQLSERVER.id;
        case "MariaDBDatabase":
        case "MariaDBIL":
            return DB_PROVIDERS.MARIADB.id;
        case "MariaDBXpand":
            return DB_PROVIDERS.MARIADBXPAND.id;
        case "MSJet":
            return DB_PROVIDERS.MSJET.id;
        case "OJet":
            return DB_PROVIDERS.OJET.id;
        case "YugabyteDB":
            return DB_PROVIDERS.YUGABYTE.id;
        case "BigQuery":
            return DB_PROVIDERS.BIGQUERY.id;
        case "Snowflake":
            return DB_PROVIDERS.SNOWFLAKE.id;
        case "DeltaLake":
            return "DELTALAKE";
        case "AzureSQLDWH":
            return "AZURESYNAPSE";
        case "SalesForce":
        case "SalesforceCDC":
        case "Salesforce":
            return DB_PROVIDERS.SALESFORCE.id;
        case "ServiceNow":
            return DB_PROVIDERS.SERVICENOW.id;
        case "SalesforcePardot":
            return DB_PROVIDERS.SALESFORCEPARDOT.id;
        case "HubSpot":
            return DB_PROVIDERS.HUBSPOT.id;
        case "Zendesk":
            return DB_PROVIDERS.ZENDESK.id;
        case "Stripe":
            return DB_PROVIDERS.STRIPE.id;
        case "FabricDataWarehouse":
            return "FABRIC";
        case "Jira":
            return DB_PROVIDERS.JIRA.id;
        case "Intercom":
            return DB_PROVIDERS.INTERCOM.id;
        case "GoogleAds":
            return DB_PROVIDERS.GOOGLEADS.id;
        default:
            return adapter.toUpperCase();
    }
};
